import { call, put, takeLatest } from "redux-saga/effects";
import {
  getFoundationAddressesSuccess,
  getFoundationAddressesFailure,
} from "./FoundationAddresses.actions";
import { FoundationAddressesService } from "./FoundationAddresses.store";

function* foundationAddressesSaga() {
  try {
    const foundationAddressesService = new FoundationAddressesService();
    const data = yield call(
      foundationAddressesService.fetchFoundationAddresses
    );
    yield put(getFoundationAddressesSuccess(data));
  } catch (error) {
    yield put(getFoundationAddressesFailure(error));
  }
}

export function* foundationAddressesSagas() {
  const GET_FOUNDATIONADDRESSES = "GET_FOUNDATIONADDRESSES";
  yield takeLatest(GET_FOUNDATIONADDRESSES, foundationAddressesSaga);
}
